/**
 * Created by Yoyo Fang on 06/23/2020.
 * Description:
 * Intralinks folder grids inline buttons
 * ------ maintenance history ------
 */

import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IntralinksFile } from '../../tamalelibs/models/intralinks.model';
import { FileHelperService } from '../../services/file-helper.service';

@Component({
    selector: 'tam-intralinks-folder-name',
    templateUrl: './intralinks-folder-name.component.html',
    styleUrls: ['./intralinks-folder-name.component.scss']
})
export class IntralinksFolderNameComponent implements ICellRendererAngularComp, OnInit {
    public item: IntralinksFile;
    // currentUser: User;
    public src = './assets/images/singlesvg/attachment.svg';
    constructor(
        private _fileHelperService: FileHelperService
    ) { }

    agInit(params: any): void {
        this.item = params.data;
        if (this.item.entityType === 'DOCUMENT' && this.item.extension) {
            const iconFileName = this._fileHelperService.getIconFileName(this.item.extension.replace('.', ''));
            this.src = './assets/images/singlesvg/' + iconFileName;
        } else {
            this.src = './assets/images/folder.png';
        }
    }
    ngOnInit() {
        // this.currentUser = this._storeQuerier.getCurrentUser();
    }

    refresh(): boolean {
        return true;
    }
}
